var o = Object.defineProperty;
var r = (n, t, i) => t in n ? o(n, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : n[t] = i;
var e = (n, t, i) => r(n, typeof t != "symbol" ? t + "" : t, i);
import { HttpClient as a, httpClient as s } from "../../httpClient.js";
class p extends a {
  constructor() {
    super(...arguments);
    e(this, "endpoint", "/users/current-user/notifications");
  }
  async getAll() {
    return s.get(this.endpoint);
  }
  async markAsRead(i) {
    return s.put(`${this.endpoint}/${i}`, {});
  }
}
const d = new p();
export {
  d as default
};
